import React from 'react';

import type { AppHomeProps } from '../../common/types';

/**
 * __App Home__
 *
 * Renders the app icon and title shown at the start of the top navigation.
 *
 * This is a stub implementation. It renders the `icon` and the title
 * (`customTitle` when provided, otherwise `appName`). A future iteration will
 * replace this with the ADS `AppLogo` / `CustomTitle` primitives.
 */
export function AppHome(props: Partial<AppHomeProps>): JSX.Element {
	const { appName, customTitle, icon, testId } = props;

	const title = customTitle ?? appName;

	return (
		<span data-testid={testId}>
			{icon ? (
				<img
					src={icon}
					alt=""
					aria-hidden="true"
					width={24}
					height={24}
					data-testid={testId && `${testId}--icon`}
				/>
			) : null}
			{title}
		</span>
	);
}
